import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const DELETE_CONTENT_SNIPPET = gql`
  mutation deleteContentSnippet($contentSnippetId: Int!) {
    contentSnippet {
      deleteSnippet(contentSnippetId: $contentSnippetId)
    }
  }
`;

const deleteContentSnippetRequest = ({
  contentSnippetId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={DELETE_CONTENT_SNIPPET}>
    {(deleteSnippet, { loading, error, data }) => {
      const variables = {
        contentSnippetId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={deleteSnippet}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

deleteContentSnippetRequest.propTypes = {
  contentSnippetId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
};

export default deleteContentSnippetRequest;
